import { dcFactory } from "dc";

import ServiceDirectorySearchComponent from "./js/asd-search.component";
dcFactory.register(ServiceDirectorySearchComponent);

